// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { stepperStyles } from "@steiner/App/Widgets/Stepper/Stepper";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

stepperStyles.container = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
    `,
};

stepperStyles.stepWrapper = {
    css: css`
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        &[data-clickable="false"] {
            cursor: not-allowed;
        }
        &[data-clickable="true"] {
            cursor: pointer;
            
            & > .step-label {
                color: ${color("common.ui8")};
            }

            &:hover {
                & > .step-number {
                    background: ${color("common.ui9")};
                }
                & > .step-label {
                    color: ${color("common.ui9")};
                }
            }
        }
    `,
};

stepperStyles.stepNumber = {
    size: 12,
    weight: 500,
    css: css`
        letter-spacing: 0;
        line-height: 15px;
        flex-shrink: 0;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: ${color("text.main", 0.5)};
        color: ${color("common.ui1")};
        margin: 0;
        &[data-status="active"],
        &[data-status="complete"] {
            background: ${color("common.ui10")};
        }
        ${xScreen("lte", "md")} {
            width: 32px;
            height: 32px;
            font-size: 14px;
        }
    `,
};

stepperStyles.stepLabel = {
    size: 14,
    weight: "bold",
    css: css`
        letter-spacing: 0;
        line-height: 16px;
        color: ${color("text.main", 0.5)};
        &[data-status="active"],
        &[data-status="complete"],
        &[data-status="visitedStep"] {
            color: ${color("common.ui10")};
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

stepperStyles.stepSeparator = {
    css: css`
        width: 100%;
        height: 1px;
        border-radius: 2px;
        background: ${color("text.main", 0.5)};
        flex: 1 1 0%;
        &[data-status="complete"] {
            height: 4px;
            background: ${color("common.ui10")};
        }
    `,
};
